// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../../../imageLarge.fragment.generated';
import { QuestionnaireQuestionChoiceOptionContentImageCardConditionalFragmentDoc } from './QuestionnaireQuestionChoiceOptionContentImageCardConditional.fragment.generated';
export const QuestionnaireQuestionChoiceOptionContentImageCardFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionContentImageCard on QuestionnaireQuestionChoiceOptionContentImageCard {
  __typename
  image {
    url
    ...imageLarge
  }
  title
  description
  conditionalContent {
    ...questionnaireQuestionChoiceOptionContentImageCardConditional
  }
}
    ${ImageLargeFragmentDoc}
${QuestionnaireQuestionChoiceOptionContentImageCardConditionalFragmentDoc}`;